module.exports = __webpack_public_path__ + "img/acasia-icon.9dd2a827.png";